var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Group_43",
    width: 120,
    height: 127,
    "data-name": "Group 43",
    viewBox: "0 0 120 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-width:2px}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_8",
    d: "M0 0H120V127H0z",
    "data-name": "Rectangle 8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_42",
    "data-name": "Group 42",
    transform: "translate(48.5 52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_26",
    d: "M1882.679 2508v23",
    className: "prefix__cls-1",
    "data-name": "Path 26",
    transform: "translate(-1871.179 -2508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_27",
    d: "M0 0v23",
    className: "prefix__cls-1",
    "data-name": "Path 27",
    transform: "rotate(-90 5.75 5.75)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.eae5b7adafda8594abbcc159f83c489c.svg";
export { ForwardRef as ReactComponent };